
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12 6c-5.5228 0-10 4.4772-10 10 0 0.5523-0.44772 1-1 1-0.55228 0-1-0.4477-1-1 0-6.6274 5.3726-12 12-12 2.226 0 4.3105 0.60612 6.0974 1.6623l-1.4703 1.4703c-1.3836-0.72348-2.9576-1.1326-4.6271-1.1326zm8.8677 5.3734 1.4703-1.4703c1.056 1.7868 1.662 3.8711 1.662 6.0969 0 0.5523-0.4477 1-1 1s-1-0.4477-1-1c0-1.6693-0.409-3.2431-1.1323-4.6266zm-0.5753-5.0798c0.3905-0.39053 1.0237-0.39053 1.4142 0 0.3905 0.39052 0.3905 1.0237 0 1.4142l-6.9989 6.999c0.1874 0.3916 0.2923 0.8302 0.2923 1.2933 0 1.6568-1.3431 3-3 3s-3-1.3432-3-3c0-1.6569 1.3431-3 3-3 0.4632 0 0.9019 0.105 1.2935 0.2924l6.9989-6.9989zm-8.2924 10.706c0.5523 0 1-0.4477 1-1s-0.4477-1-1-1-1 0.4477-1 1 0.4477 1 1 1z","clip-rule":"evenodd","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    